import { Button, Dialog } from '@busybusy/webapp-react-ui';
import { CheckCircleIcon, CloseIcon } from 'assets/icons';
import classNames from 'classnames';
import IconButton from 'components/foundation/buttons/IconButton/IconButton';
import { ClassName } from 'types/ClassName';
import { t } from 'utils/localize';
import './ReferralConfirmationDialog.scss';

export interface IReferralConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  className?: ClassName;
}

const ReferralConfirmationDialog = ({ isOpen, onClose, className }: IReferralConfirmationDialogProps) => {
  const steps = [
    t('Someone from our team will call them within 3-5 business days.'),
    t("We'll let them know you sent them. No hard sell."),
    t("If they sign up, we'll send you both a $100 gift card."),
  ];

  return (
    <Dialog isOpen={isOpen} onClose={onClose} size="full" hasDismiss={false}>
      <div className={classNames('referral-confirmation-dialog', className)}>
        <IconButton
          className="referral-confirmation-dialog-close"
          svg={CloseIcon}
          onClick={onClose}
          aria-label={t('Close')}
        />

        <div className="referral-confirmation">
          <CheckCircleIcon className="referral-confirmation-icon" viewBox="0 0 24 24" />
          <h2>{t('Thanks for sending them our way.')}</h2>

          <div className="referral-confirmation-next">
            <h4>{t('What happens next:')}</h4>
            <ol>
              {steps.map((step) => (
                <li key={step}>{step}</li>
              ))}
            </ol>
          </div>

          <Button type="secondary" onClick={onClose}>
            {t('Close')}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default ReferralConfirmationDialog;
